module.exports = __webpack_public_path__ + "media/images/covid/banner/sidebar/id-f8f343ac16988450ddfad99bedbda7bf.jpg";